import React, { Component } from "react";

// import {Link} from 'react-router-dom'
// import {Link} from 'react-router-dom'
import { Grid, Menu, Header, Image } from "semantic-ui-react";

import Footer from "../../../../Footer";

import colors from "../../../../colors";
import NRSC from "../../../../../images/ISRO_NRSC_Logo.png";
import NHP from "../../../../../images/NHPLogo.png";

import decode from "jwt-decode";
import {
  Navbar,
  NavbarNav,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import { AuthConsumer } from "../../../../AuthContext";
//import login from './Login1'
// import {Button} from 'react-materialize'

class HNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      activeItem: "sessionwise",
    };
  }

  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    return (
      <div className="wrapper">
        <Grid
          columns="equal"
          divided
          inverted
          style={{ marginLeft: "0rem", marginRight: "-2rem" }}
        >
          <Grid.Row
            style={{ paddingTop: "1em", paddingBottom: "0em" }}
            stretched
          >
            <Grid.Column>
              <Menu
                as={Header}
                attached
                style={{ backgroundColor: colors.header }}
              >
                <Grid.Column floated="left">
                  <Header as="h3">
                    {" "}
                    <Image src={NRSC} />
                  </Header>
                </Grid.Column>
                <Grid.Column>
                  <Header as="h1" textAlign="center">
                    <Header.Content>Capacity Building</Header.Content>
                  </Header>
                </Grid.Column>
                <Grid.Column floated="right">
                  <Header as="h3" textAlign="left">
                    <Image src={NHP} />
                  </Header>
                </Grid.Column>
              </Menu>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <AuthConsumer>
          {({ isAuth, logout, username }) => (
            <Navbar color="indigo" dark expand="md" scrolling>
              {/* <NavbarBrand href="#">
                        <strong>NHP Training - Feedback</strong>
                    </NavbarBrand> */}

              <NavbarNav left>
                <NavItem>
                  <NavLink to="/Home">
                    <Menu.Item name="NHP Home" />
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/trainingnew">
                    <Menu.Item name="Training  Home" />
                  </NavLink>
                </NavItem>
              </NavbarNav>
              <Collapse isOpen={this.state.collapse} navbar>
                {isAuth || localStorage.getItem("token") !== null ? (
                  <NavbarNav right>
                    <NavItem>
                      <NavLink
                        to={`/feedbackMenu/sessionwise/${
                          decode(localStorage.getItem("token")).id
                        }`}
                      >
                        <u>Session Wise Feedback</u>{" "}
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        // disabled
                        // onClick={this.handleItemClick}
                        to={`/feedbackMenu/overall/${
                          decode(localStorage.getItem("token")).id
                        }`}
                      >
                        <u> Overall Feedback</u>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <Button outline size="sm" color="yellow">
                        Welcome {decode(localStorage.getItem("token")).name}
                      </Button>
                    </NavItem>
                    <NavItem>
                      <Button size="sm" onClick={logout}>
                        logout
                      </Button>
                    </NavItem>
                  </NavbarNav>
                ) : null}
              </Collapse>
            </Navbar>
          )}
        </AuthConsumer>
        <div className="main">{this.props.children}</div>

        <Footer />
      </div>
    );
  }
}
export default HNavbar;
